import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const VenueContext = createContext(null);

export function VenueProvider({ children }) {
  const { user } = useAuth();
  const [ctx, setCtx] = useState(null);
  const [activeVenue, setActive] = useState(localStorage.getItem("ps_active_venue") || null);

  const load = useCallback(async () => {
    if (!user) { setCtx(null); return; }
    try {
      const { data } = await api.get("/plus/context");
      setCtx(data);
      const ids = (data.venues || []).map((v) => v.id);
      let cur = localStorage.getItem("ps_active_venue");
      if (!cur || !ids.includes(cur)) {
        cur = data.default_venue_id || ids[0] || null;
      }
      if (cur) { localStorage.setItem("ps_active_venue", cur); setActive(cur); }
    } catch { setCtx(null); }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const setActiveVenue = useCallback((id) => {
    localStorage.setItem("ps_active_venue", id);
    setActive(id);
    window.dispatchEvent(new Event("venue-changed"));
  }, []);

  const venues = ctx?.venues || [];
  const current = venues.find((v) => v.id === activeVenue) || venues[0] || null;

  return (
    <VenueContext.Provider value={{
      role: ctx?.role, groups: ctx?.groups || [], venues, activeVenue,
      currentVenue: current, setActiveVenue, reload: load,
    }}>
      {children}
    </VenueContext.Provider>
  );
}

export const useVenue = () => useContext(VenueContext) || {};
